'use strict'
import serviceBase from './serviceBase'
const reserveYourStayService = {
    reserveYourStay:(data)=>serviceBase.post('/reserveyourstay',data),
    googleReserveYourStay:(data)=>serviceBase.post('/reserveyourstay/google',data),
    baeReserveYourStay:(data)=>serviceBase.post('/reserveyourstay/bae',data),
}
export default reserveYourStayService